import { defineMessages } from 'react-intl'

const scope = `procurify.platform.approval-routing.components.ApproverSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select an approver',
  },
  selfApprovalLabel: {
    id: `${scope}.selfApprovalLabel`,
    defaultMessage: 'self-approve',
  },
})
